import { createAction } from '@reduxjs/toolkit';
import CopyPasteNodeError from '../../../utils/error/CopyPasteNodeError';

export const newCopyPasteError = createAction('error/copy-paste', (message) => ({
  error: new CopyPasteNodeError(message),
}));
